// 組織管理モジュール ページ国際化
export default {
  // ─── 共通 ──────────────────────────────────────────────────────────────
  'org.common.status.enable': '有効化',
  'org.common.status.disable': '無効化',
  'org.common.status.enabled': '有効',
  'org.common.status.disabled': '無効',
  'org.common.status.active': '有効',
  'org.common.status.inactive': '未有効',
  'org.common.status.normal': '正常',
  'org.common.confirm': '確認',
  'org.common.cancel': 'キャンセル',
  'org.common.save': '保存',
  'org.common.reset': 'リセット',
  'org.common.submit': '送信',
  'org.common.export': 'エクスポート',
  'org.common.export.loading': 'エクスポートデータを取得中です。しばらくお待ちください…',
  'org.common.export.fetchFail': 'エクスポートデータの取得に失敗しました',
  'org.common.export.noData': 'エクスポートするデータがありません',
  'org.common.export.success': 'エクスポートしました',
  'org.common.export.fail': 'エクスポートに失敗しました。もう一度お試しください',
  'org.common.export.queryCondition': '検索条件',
  'org.common.export.totalRecords': '合計 {count} 件',
  'org.common.status.updating': 'ステータスを更新中…',
  'org.common.status.updateSuccess': '更新しました',
  'org.common.status.updateFail': '更新に失敗しました。もう一度お試しください',
  'org.common.exportOptionExcel': 'Excel (.xlsx)',
  'org.common.exportOptionCsv': 'CSV (.csv)',
  'org.common.exportOptionPdf': 'PDF (.pdf)',
  'org.common.print': '印刷',
  'org.common.new': '新規作成',
  'org.common.edit': '編集',
  'org.common.backToList': 'リストに戻る',
  'org.common.field.status': 'ステータス',
  'org.common.field.remark': '備考',
  'org.common.field.creator': '作成者',
  'org.common.field.createTime': '作成日時',
  'org.common.field.updateTime': '更新日時',
  'org.common.field.sort': '並び順',
  'org.common.field.operation': '操作',
  'org.common.label.role': 'ロール',
  'org.common.label.creator': '作成者',
  'org.common.label.company': '会社',
  'org.common.label.dept': '部門',
  'org.common.sex.unknown': '不明',
  'org.common.sex.male': '男性',
  'org.common.sex.female': '女性',

  // ─── 会社管理 ──────────────────────────────────────────────────────────────
  'org.company.title': '会社管理',
  'org.company.new': '新規会社',
  'org.company.edit.title': '会社情報を編集',
  'org.company.setting.title': '設定',
  'org.company.total': '会社総数',
  'org.company.filter.jointQuery': '結合検索',
  'org.company.filter.keyword.placeholder': 'キーワードを入力（会社/グループタグ）',
  'org.company.filter.tagLabel': 'グループタグ',
  'org.company.filter.name.placeholder': '会社名を入力してください',
  'org.company.filter.tag.placeholder': 'グループタグを入力してください',
  'org.company.field.id': '会社ID',
  'org.company.field.name': '会社名',
  'org.company.field.code': '会社コード',
  'org.company.field.group': 'グループタグ',
  'org.company.field.sort': '並び順',
  'org.company.field.userCount': 'ユーザー数',
  'org.company.form.name.label': '会社名',
  'org.company.form.name.required': '会社名を入力してください',
  'org.company.form.code.label': '会社コード',
  'org.company.form.code.required': '会社コードを入力してください',
  'org.company.form.group.label': 'グループタグ',
  'org.company.form.folderTemplate.label': 'フォルダテンプレート',
  'org.company.form.folderTemplate.placeholder': 'フォルダテンプレートを選択してください',
  'org.company.form.sort.label': '並び順',
  'org.company.form.sort.required': '並び順を入力してください',
  'org.company.form.status.placeholder': 'ステータスを選択してください',
  'org.company.form.remark.label': '備考',
  'org.company.form.remark.placeholder': '備考を入力してください',
  'org.company.error.notFound': '会社情報が見つかりません',
  'org.company.error.fetchFail': '会社情報の取得に失敗しました',
  'org.company.setting.usedToken': '現在のToken使用量',
  'org.company.setting.daily': '日次',
  'org.company.setting.weekly': '週次',
  'org.company.setting.monthly': '月次',
  'org.company.setting.resetConfirm': '使用量を0にリセットしますか？',
  'org.company.setting.companyQuota': '会社クォータ',
  'org.company.setting.userDefaultQuota': 'ユーザーデフォルトクォータ',
  'org.company.setting.dailyQuota': '日次クォータ（tokens）',
  'org.company.setting.weeklyQuota': '週次クォータ（tokens）',
  'org.company.setting.monthlyQuota': '月次クォータ（tokens）',
  'org.company.setting.zeroUnlimited': '0は無制限を意味します',
  'org.company.setting.saveSuccess': '設定を保存しました',
  'org.company.setting.saveFail': '設定の保存に失敗しました',
  'org.company.setting.resetSuccess': '使用量のリセットに成功しました',
  'org.company.setting.resetFail': 'リセットに失敗しました。もう一度お試しください',
  'org.company.setting.fetchFail': '設定の取得に失敗しました',

  // ─── 部署管理 ──────────────────────────────────────────────────────────────
  'org.dept.title': '部署管理',
  'org.dept.new': '新規部署',
  'org.dept.edit.title': '部署情報を編集',
  'org.dept.total': '部署総数',
  'org.dept.field.id': '部署ID',
  'org.dept.field.name': '部署名',
  'org.dept.field.company': '所属会社',
  'org.dept.field.deptCount': '部署人数',
  'org.dept.form.name.label': '部署名',
  'org.dept.form.name.required': '部署名を入力してください',
  'org.dept.form.name.placeholder': '部署名を入力してください',
  'org.dept.form.company.label': '所属会社',
  'org.dept.form.company.required': '会社を選択してください',
  'org.dept.form.company.placeholder': '会社を選択してください',
  'org.dept.form.sort.label': '並び順',
  'org.dept.form.sort.placeholder': '並び順を入力してください',
  'org.dept.form.remark.label': '備考',
  'org.dept.form.remark.placeholder': '備考を入力してください',
  'org.dept.error.notFound': '部署情報が見つかりません',
  'org.dept.error.fetchFail': '部署情報の取得に失敗しました',
  'org.dept.filter.keyword.placeholder': 'キーワードを入力',
  'org.dept.filter.name.placeholder': '部署名を入力',
  'org.dept.filter.company.placeholder': '会社を選択',

  // ─── ロール管理 ──────────────────────────────────────────────────────────────
  'org.role.title': 'ロール管理',
  'org.role.new': '新規ロール',
  'org.role.add.title': 'ロール追加',
  'org.role.edit.title': 'ロール編集',
  'org.role.edit.breadcrumb': 'ロールを編集',
  'org.role.total': 'ロール総数',
  'org.role.field.id': 'ロールID',
  'org.role.field.name': 'ロール名',
  'org.role.field.ownerCompany': '所属会社',
  'org.role.field.description': '説明（任意）',
  'org.role.field.basicInfo': '基本情報',
  'org.role.form.name.label': 'ロール名',
  'org.role.form.name.required': 'ロール名を入力してください',
  'org.role.form.name.placeholder': 'ロール名を入力してください',
  'org.role.form.description.label': '説明（任意）',
  'org.role.form.description.placeholder': '説明を入力してください',
  'org.role.perm.functionTree': '機能ツリー',
  'org.role.perm.permCode': '権限コード',
  'org.role.perm.view': '閲覧',
  'org.role.perm.edit': '編集',
  'org.role.perm.delete': '削除',
  'org.role.perm.add': '追加',
  'org.role.perm.export': 'エクスポート',
  'org.role.perm.print': '印刷',
  'org.role.perm.searchPlaceholder': 'メニュー名または権限コードで検索',
  'org.role.action.batchEnable': '一括有効化',
  'org.role.action.batchDisable': '一括無効化',
  'org.role.action.batchOperation': '一括操作',
  'org.role.action.copyRole': 'ロールをコピー',
  'org.role.action.select': '選択',
  'org.role.action.queryRelated': '関連検索',
  'org.role.error.noRoleId': 'パラメータエラー：ロールIDがありません',
  'org.role.error.fetchFail': 'ロール詳細の取得に失敗しました',
  'org.role.error.updateFail': '更新に失敗しました',
  'org.role.error.saveFail': '保存に失敗しました',
  'org.role.form.company.required': '所属会社を選択してください',
  'org.role.form.company.placeholder': '会社を選択',
  'org.role.form.remark.placeholder': '最大3行まで',
  'org.role.filter.keyword.placeholder': 'キーワードを入力（ロール/作成者/会社）',
  'org.role.filter.createBy.placeholder': '作成者を選択',
  'org.role.filter.company.placeholder': '会社を選択',

  // v01b13 ナレッジベース権限（ロール側エントリ）
  'org.role.kbAuth.cardTitle': 'ナレッジベース権限',
  'org.role.kbAuth.available': '選択可能（会社別）',
  'org.role.kbAuth.granted': '付与済み',
  'org.role.kbAuth.saved': '保存しました',
  'org.role.kbAuth.bypassed': '管理者 / 全社ロールは全ナレッジベースを既定で利用できます。',
  'org.role.kbAuth.noCompany': '会社未割当',

  // ─── ユーザー管理 ──────────────────────────────────────────────────────────────
  'org.user.title': 'ユーザー管理',
  'org.user.new': '新規ユーザー',
  'org.user.copy': 'ユーザーをコピー',
  'org.user.edit.title': 'ユーザーを編集',
  'org.user.edit.subtitle': '* は必須項目です',
  'org.user.section.basic': '基本情報',
  'org.user.section.org': '組織と権限',
  'org.user.section.contact': '連絡先',
  'org.user.form.weightHint': '重み値は {max} 未満にしてください',
  'org.user.detail.title': 'ユーザー詳細',
  'org.user.total': 'ユーザー総数',
  'org.user.view.card': 'カード',
  'org.user.view.list': 'リスト',
  'org.user.field.id': 'ユーザーID',
  'org.user.field.account': 'アカウント名',
  'org.user.field.nickname': 'ニックネーム',
  'org.user.field.email': 'メールアドレス',
  'org.user.field.company': '所属会社',
  'org.user.field.dept': '所属部署',
  'org.user.field.deptShort': '部署',
  'org.user.field.phone': '電話番号',
  'org.user.field.phone1': '予備電話番号',
  'org.user.col.phone1': '電話番号1',
  'org.user.col.phone2': '電話番号2',
  'org.common.search.placeholder': '検索',
  'org.user.field.weight': 'アカウント優先度',
  'org.user.field.sex': '性別',
  'org.user.form.account.required': 'アカウント名を入力してください',
  'org.user.form.account.maxLen': 'アカウント名は最大50文字です',
  'org.user.form.account.pattern': 'アカウント名は英数字と .-_ 記号のみ使用できます',
  'org.user.form.account.placeholder': 'アカウント名を入力してください',
  'org.user.form.nickname.required': 'ニックネームを入力してください',
  'org.user.form.nickname.placeholder': 'ニックネームを入力してください',
  'org.user.form.email.required': 'メールアドレスを入力してください',
  'org.user.form.email.invalid': '有効なメールアドレスを入力してください',
  'org.user.form.email.placeholder': 'メールアドレスを入力してください',
  'org.user.form.sex.required': '性別を選択してください',
  'org.user.form.status.required': 'ステータスを選択してください',
  'org.user.form.company.placeholder': '会社名で検索してください',
  'org.user.form.company.required': '会社を選択してください',
  'org.user.form.dept.placeholder': '部署を選択してください',
  'org.user.form.phone.placeholder': '電話番号を入力してください',
  'org.user.form.phone1.placeholder': '予備電話番号を入力してください',
  'org.user.form.weight.required': 'アカウント優先度を入力してください',
  'org.user.form.weight.placeholder': 'アカウント優先度を入力してください',
  'org.user.form.weight.label': 'アカウント優先度（{max}未満）',
  'org.user.filter.keyword.placeholder': 'キーワードを入力（アカウント/ニックネーム/メール/会社/部門）',
  'org.user.filter.company.placeholder': '会社を入力',
  'org.user.filter.phone1.placeholder': '電話番号1を入力',
  'org.user.filter.phone2.placeholder': '電話番号2を入力',
  'org.user.filter.nickname.placeholder': 'ニックネームを選択または入力',
  'org.user.filter.account.placeholder': 'アカウントを選択または入力',
  'org.user.filter.email.placeholder': 'メールを選択または入力',
  'org.user.filter.companySelect.placeholder': '会社を選択または入力',
  'org.user.filter.dept.placeholder': '部署を選択または入力',
  'org.user.add.success': '追加しました',
  'org.user.add.fail': '追加に失敗しました',
  'org.user.add.copyFetchFail': 'コピー元ユーザー情報の取得に失敗しました',
  'org.user.add.systemError': 'システムエラーが発生しました。後でもう一度お試しください',
  'org.user.add.modalTitle': 'ユーザーが追加されました',
  'org.user.add.modalDesc': '新しく作成されたユーザーの情報です。初期パスワードを安全に保管してください。',
  'org.user.add.copyAccountPwd': 'アカウントとパスワードをコピー',
  'org.user.add.close': '閉じる',
  'org.user.add.copyText': 'アカウント：{account}\nパスワード：{password}',
  'org.user.add.copySuccess': 'アカウントとパスワードをクリップボードにコピーしました',
  'org.user.add.copyFail': 'コピーに失敗しました。手動でコピーしてください',
  'org.user.add.desc.account': 'ユーザーアカウント',
  'org.user.add.desc.initPwd': '初期パスワード',
  'org.user.add.desc.phone': '電話番号',
  'org.user.add.desc.createTime': '作成日時',
  'org.user.add.subtitle': '* は必須項目です。送信後、初期パスワードが自動生成されます。',
  'org.user.edit.success': '更新しました',
  'org.user.edit.fail': '更新に失敗しました',
  'org.user.edit.fetchFail': 'ユーザー情報の取得に失敗しました',
  'org.user.edit.noId': 'ユーザーIDが見つかりません',
  'org.user.edit.systemError': 'システムエラーが発生しました。後でもう一度お試しください',
  'org.user.action.editProfile': 'プロフィール編集',
  'org.user.action.permManage': '権限管理',
  'org.user.action.quota': 'クォータ',
  'org.user.action.copy': 'コピー',
  'org.user.action.enable': '有効化',
  'org.user.action.disable': '無効化',
  'org.user.action.batchImport': '一括インポート',
  'org.user.detail.noData': 'データなし',
  'org.user.detail.back': '戻る',
  'org.user.detail.roleInfo': 'ロール情報',
  'org.user.detail.roleField': 'ロール',

  // 一括インポート
  'org.user.batchImport.title': 'ユーザー一括インポート',
  'org.user.batchImport.downloadTemplate': 'テンプレートをダウンロード',
  'org.user.batchImport.uploadCard': 'インポートファイルをアップロード',
  'org.user.batchImport.guide.title': 'インポート説明',
  'org.user.batchImport.guide.basicRequire': '基本要件',
  'org.user.batchImport.guide.req1': 'まずテンプレートをダウンロードしてください。1行目のヘッダーは変更しないでください。2行目からデータを入力してください。',
  'org.user.batchImport.guide.req2': '.xlsxおよび.xls形式に対応しています。ファイル選択後、自動的にインポートが開始されます。',
  'org.user.batchImport.guide.req3': 'インポート成功後、システムが自動的に初期パスワードを生成します。結果ページに表示されますので、スクリーンショットしてユーザーに通知してください。',
  'org.user.batchImport.guide.fieldDesc': 'フィールド説明（全10列）',
  'org.user.batchImport.guide.colName': '列名',
  'org.user.batchImport.guide.colRequired': '必須',
  'org.user.batchImport.guide.colRule': '入力ルール',
  'org.user.batchImport.guide.required': '必須',
  'org.user.batchImport.guide.optional': '任意',
  'org.user.batchImport.guide.row.account.rule': 'ユニーク。既存のアカウントと重複不可',
  'org.user.batchImport.guide.row.nickname.rule': '表示名。重複可',
  'org.user.batchImport.guide.row.status.rule': '1 = 有効（デフォルト）、0 = 無効',
  'org.user.batchImport.guide.row.company.rule': 'システムに既存の会社名と完全一致が必要',
  'org.user.batchImport.guide.row.dept.rule': 'システムに既存の部署名と完全一致が必要。空白の場合は部署未割り当て',
  'org.user.batchImport.guide.row.weight.rule': '正の整数。値が大きいほど操作権限が高い。空白の場合はデフォルト値を使用',
  'org.user.batchImport.guide.row.email.rule': '通知受信用の有効なメールアドレス形式',
  'org.user.batchImport.guide.row.phone.rule': '11桁の数字',
  'org.user.batchImport.guide.row.sex.rule': 'M = 男性、F = 女性。空白の場合は不明',
  'org.user.batchImport.upload.dragging': 'クリックまたはファイルをここにドラッグしてアップロード',
  'org.user.batchImport.upload.hint': 'ファイル選択後、自動的にインポートが開始されます。.xlsxおよび.xls形式に対応しています。',
  'org.user.batchImport.upload.spinning': 'アップロードしてインポート中。しばらくお待ちください...',
  'org.user.batchImport.result.success': 'インポート成功。{count}件のレコードをインポートしました',
  'org.user.batchImport.result.partial': 'インポート完了：{count}件成功。一部のデータのインポートに失敗しました',
  'org.user.batchImport.result.continue': '続けてインポート',
  'org.user.batchImport.result.backToList': 'ユーザーリストに戻る',
  'org.user.batchImport.result.failDetail': '失敗詳細',
  'org.user.batchImport.result.countUnit': '件',
  'org.user.batchImport.result.successList': 'インポート成功ユーザー',
  'org.user.batchImport.result.pwdWarning': '初期パスワードを速やかに記録してユーザーに通知してください。ページを閉じると再度確認できません。',
  'org.user.batchImport.result.pwdNotice': '初期パスワードはこのページでのみ表示されます。スクリーンショットまたはコピーして保存してください。',
  'org.user.batchImport.error.importFail': 'インポートに失敗しました。もう一度お試しください',
  'org.user.batchImport.error.uploadFail': 'アップロードに失敗しました。ネットワークを確認してもう一度お試しください',
  'org.user.batchImport.col.account': 'アカウント名',
  'org.user.batchImport.col.nickname': 'ニックネーム',
  'org.user.batchImport.col.email': 'メールアドレス',
  'org.user.batchImport.col.initPwd': '初期パスワード',

  // クォータモーダル
  'org.user.quota.title': 'クォータ管理',
  'org.user.quota.usedToken': '現在のToken使用量',
  'org.user.quota.daily': '日次',
  'org.user.quota.weekly': '週次',
  'org.user.quota.monthly': '月次',
  'org.user.quota.resetConfirm': '使用量を0にリセットしますか？',
  'org.user.quota.reset': 'リセット',
  'org.user.quota.dailyLimit': '日次制限（tokens）',
  'org.user.quota.weeklyLimit': '週次制限（tokens）',
  'org.user.quota.monthlyLimit': '月次制限（tokens）',
  'org.user.quota.zeroUnlimited': '0は無制限を意味します',
  'org.user.quota.saveSuccess': 'クォータを保存しました',
  'org.user.quota.saveFail': '保存に失敗しました。もう一度お試しください',
  'org.user.quota.fetchFail': 'クォータ情報の取得に失敗しました',
  'org.user.quota.fetchFail2': 'クォータ情報の取得に失敗しました。もう一度お試しください',
  'org.user.quota.resetSuccess': '使用量のリセットに成功しました',
  'org.user.quota.resetFail': 'リセットに失敗しました。もう一度お試しください',

  // ロール選択モーダル
  'org.user.roleModal.title': 'ロールを選択',
  'org.user.roleModal.ok': '選択を確定',
  'org.user.roleModal.headerTitle': 'ロール一覧',
  'org.user.roleModal.selected': '{count}件選択済み',
  'org.user.roleModal.col.name': 'ロール名',
  'org.user.roleModal.col.status': 'ステータス',
  'org.user.roleModal.col.remark': '備考',
  'org.user.roleModal.col.creator': '作成者',
  'org.user.roleModal.col.createTime': '作成日時',
  'org.user.roleModal.status.normal': '正常',
  'org.user.roleModal.status.disabled': '無効',
  'org.user.roleModal.name.placeholder': 'ロール名を入力してください',
  'org.user.roleModal.search.placeholder': 'キーワードを入力（ロール/作成者/会社）',

  // プライベート権限モーダル
  'org.user.permModal.title': 'プライベート権限を設定',
  'org.user.permModal.searchPlaceholder': 'メニュー名または権限コードで検索',
  'org.user.permModal.added': '個別追加',
  'org.user.permModal.removed': '個別削除',
  'org.user.permModal.error.noId': 'パラメータエラー：ユーザーIDまたはロールIDがありません',
  'org.user.permModal.error.fetchFail': '権限データの取得に失敗しました',
  'org.user.permModal.saveSuccess': '保存しました',
  'org.user.permModal.saveFail': '保存に失敗しました',

  // ユーザー詳細ドロワー
  'org.user.drawer.title': 'ユーザー詳細',
  'org.user.drawer.tab.basic': '基本情報',
  'org.user.drawer.tab.roles': 'ロール情報',
  'org.user.drawer.col.roleName': 'ロール名',
  'org.user.drawer.col.status': 'ステータス',
  'org.user.drawer.col.remark': '備考',
  'org.user.drawer.status.active': '有効',
  'org.user.drawer.status.inactive': '未有効',
  'org.user.drawer.status.enabled': '有効',
  'org.user.drawer.status.disabled': '無効',
  'org.user.drawer.noRoles': 'ロールなし',
  'org.user.drawer.field.account': 'アカウント名',
  'org.user.drawer.field.nickname': 'ニックネーム',
  'org.user.drawer.field.email': 'メールアドレス',
  'org.user.drawer.field.phone': '電話番号',
  'org.user.drawer.field.sex': '性別',
  'org.user.drawer.field.company': '所属会社',
  'org.user.drawer.field.dept': '部署',
  'org.user.drawer.field.weight': 'アカウント優先度',
  'org.user.drawer.field.createTime': '作成日時',
  'org.user.drawer.field.updateTime': '更新日時',

  // ユーザー選択モーダル
  'org.user.userModal.title': '権限を参照',
  'org.user.userModal.ok': '選択を確定',
  'org.user.userModal.headerTitle': 'ユーザー一覧',
  'org.user.userModal.selected': '{count}件選択済み',
  'org.user.userModal.col.account': 'アカウント',
  'org.user.userModal.col.nickname': 'ニックネーム',
  'org.user.userModal.col.email': 'メールアドレス',
  'org.user.userModal.col.status': 'ステータス',
  'org.user.userModal.col.company': '所属会社',
  'org.user.userModal.col.dept': '所属部署',
  'org.user.userModal.col.creator': '作成者',
  'org.user.userModal.col.weight': 'アカウント優先度',
  'org.user.userModal.status.enabled': '有効',
  'org.user.userModal.status.disabled': '無効',
  'org.user.userModal.nickname.placeholder': 'ニックネームを入力してください',
  'org.user.userModal.search.placeholder': 'キーワードを入力（アカウント/ニックネーム/メール/会社/部署）',

  // ユーザーカード
  'org.user.card.status.active': '有効',
  'org.user.card.status.inactive': '未有効',
  'org.user.card.action.lock': 'ロック',
  'org.user.card.action.enable': '有効化',
  'org.user.card.action.perm': '権限',
  'org.user.card.action.edit': '編集',
  'org.user.card.noPermission': '権限が不足しています',
  'org.user.card.nickname': 'ニックネーム',
  'org.user.card.companyName': '会社名',

  // ユーザー権限管理ページ
  'org.user.perm.pageTitle': 'ユーザー権限管理',
  'org.user.perm.isManager': '管理者',
  'org.user.perm.createdAt': '作成日',
  'org.user.perm.statusActive': '有効',
  'org.user.perm.statusInactive': '未有効',
  'org.user.perm.account': 'アカウント',
  'org.user.perm.company': '所属会社',
  'org.user.perm.phone': '電話番号',
  'org.user.perm.sex': '性別',
  'org.user.perm.col.roleName': 'ロール名',
  'org.user.perm.col.roleId': 'ロールID',
  'org.user.perm.col.status': 'ステータス',
  'org.user.perm.col.remark': '備考',
  'org.user.perm.col.grantor': '付与者',
  'org.user.perm.col.grantTime': '付与日時',
  'org.user.perm.col.ownerCompany': '所属会社',
  'org.user.perm.col.operation': '操作',
  'org.user.perm.status.normal': '正常',
  'org.user.perm.status.disabled': '無効',
  'org.user.perm.action.remove': '削除',
  'org.user.perm.action.customize': 'カスタマイズ',
  'org.user.perm.action.restore': '復元',
  'org.user.perm.btn.add': '追加',
  'org.user.perm.btn.reference': '権限を参照',
  'org.user.perm.btn.remove': '削除',
  'org.user.perm.btn.cancelSelect': '選択解除',
  'org.user.perm.selected': '{count}件選択済み',
  'org.user.perm.setManager': '管理者に設定',
  'org.user.perm.cancelManager': '管理者を解除',
  'org.user.perm.resetPwd': 'パスワードをリセット',
  'org.user.perm.confirm.setManager': '管理者設定を確認',
  'org.user.perm.confirm.cancelManager': '管理者解除を確認',
  'org.user.perm.confirm.setManagerContent': 'ユーザー {name} をシステム管理者に設定しますか？',
  'org.user.perm.confirm.cancelManagerContent': 'ユーザー {name} の管理者権限を解除しますか？',
  'org.user.perm.confirm.setManagerSuccess': 'システム管理者に設定しました',
  'org.user.perm.confirm.cancelManagerSuccess': '管理者権限を解除しました',
  'org.user.perm.confirm.resetPwd': 'パスワードリセットを確認',
  'org.user.perm.confirm.resetPwdContent': 'ユーザー {account} のパスワードをリセットしますか？',
  'org.user.perm.resetPwd.success': 'パスワードのリセットが完了しました',
  'org.user.perm.resetPwd.account': 'アカウント：',
  'org.user.perm.resetPwd.newPwd': '新しいパスワード：',
  'org.user.perm.resetPwd.tip': '新しいパスワードを安全に保管してください。ログイン後すぐに変更することをお勧めします。',
  'org.user.perm.resetPwd.ok': '了解',
  'org.user.perm.resetPwd.failPrefix': 'パスワードのリセットに失敗しました：',
  'org.user.perm.resetPwd.fail': 'パスワードのリセットに失敗しました',
  'org.user.perm.remove.confirm': '削除の確認',
  'org.user.perm.remove.content': '選択した {count} 件のロールを削除しますか？この操作は取り消せません。',
  'org.user.perm.remove.loading': '削除中...',
  'org.user.perm.remove.success': '削除しました',
  'org.user.perm.remove.fail': '削除に失敗しました',
  'org.user.perm.restore.confirm': '復元の確認',
  'org.user.perm.restore.content': 'このロールのプライベート権限をクリアしますか？復元後はロールのデフォルト権限が使用されます。',
  'org.user.perm.restore.loading': '復元中...',
  'org.user.perm.restore.success': '復元しました',
  'org.user.perm.restore.fail': '復元に失敗しました',
  'org.user.perm.reference.loading': '{count}人のユーザーの権限を参照中...',
  'org.user.perm.reference.success': '{count}人のユーザーの権限を参照しました',
  'org.user.perm.reference.fail': '権限の参照に失敗しました。後でもう一度お試しください',
  'org.user.perm.reference.noSelect': '参照するユーザーを選択してください',
  'org.user.perm.role.loading': 'ユーザーに {count} 件のロールを割り当て中...',
  'org.user.perm.role.success': 'ユーザーに {count} 件のロールを割り当てました',
  'org.user.perm.role.fail': 'ロールの割り当てに失敗しました。後でもう一度お試しください',
  'org.user.perm.role.noSelect': '少なくとも1つのロールを選択してください',
  'org.user.perm.error.noUserId': 'ユーザーIDが見つかりません',
  'org.user.perm.error.fetchFail': 'ユーザー情報の取得に失敗しました',
  'org.user.perm.error.opFail': '操作に失敗しました',
  'org.user.perm.error.opFail2': '操作に失敗しました。後でもう一度お試しください',
  'org.user.perm.perm.saveSuccess': '権限設定を更新しました',
};
